import{createSelector,createEntityAdapter} from "@reduxjs/toolkit";
import {apiSlice} from "../api/apiSlice";

const personasAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `book.id`
  selectId: p => p.personaId,

  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.title.localeCompare(b.title),
})

const initialState = personasAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getPersonas: builder.query({
      query: ()=> 'personas',
      transformResponse: responseData=>{
        return personasAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg)=>[
        {type:'Personas', id: 'LIST'},
        ...(result?.ids || []).map( id => ({type:'Personas', id}))
      ]
    }),
    addNewPersona: builder.mutation({
      query: (newPersona)=>({
        url: 'personas',
        method: 'post',
        body: newPersona
      }),
      invalidatesTags: ["Personas"]
    }),
    deletePersonas: builder.mutation({
      query: (personasIds)=>({
        url:'personas?ids='+ JSON.stringify(personasIds),
        method: 'delete',
      }),
      invalidatesTags: ["Personas"]
    }),
    editPersonas: builder.mutation({
      query: (newPersona)=>({
        url:'personas',
        method: 'put',
        body: newPersona
      }),
      invalidatesTags: ["Personas","RolesMap"]
    })
  })
});

export const { useGetPersonasQuery, useAddNewPersonaMutation, useDeletePersonasMutation, useEditPersonasMutation } = extendedApiSlice;

//A: returns the query result object
export const selectPersonasResut= extendedApiSlice.endpoints.getPersonas.select();

//A: created memoized selector
const selectPersonasData = createSelector(
  selectPersonasResut,
  personasResult => personasResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const{
  selectAll: selectAllPersonas,
  selectById: selectUserById,
  selectIds: selectpersonasIds
}= personasAdapter.getSelectors( state => selectPersonasData(state) ?? initialState );


export const selectPersonasJuridicas= createSelector(
  [selectAllPersonas],
  personas=> personas.filter(p=> !p.personaFisica)
);

export const selectPersonasFisicas= createSelector(
  [selectAllPersonas],
  personas=> personas.filter(p=> p.personaFisica && !p.eliminado)
);

export const selectAllPersonasFisicas= createSelector(
  [selectAllPersonas],
  personas=> personas.filter(p=> p.personaFisica)
);